import React, { useEffect, useState } from "react";
import { AiOutlineDelete } from "react-icons/ai";
import { useNavigate } from "react-router-dom";
import styled from "styled-components";
import { useStateContext } from "../contexts/ContextProvider";
import { HiMinus, HiOutlinePlus } from "react-icons/hi";

const SideBarProductCard = ({ cart, cartItems }) => {
  const {
    setIsScrolled,
    cartItem,
    setCartItem,
    total,
    getTotal,
    handleDelete,
  } = useStateContext();
  const [select, setSelect] = useState();
  const navigate = useNavigate();
  useEffect(() => {
    //  let cartQuantity = cartQuantityInSidebar.map((cart, i) => ( cart ))
    //   console.log('cart product sidebar', cartQuantity)
    setSelect(cart.quantity);
    getTotal();
  }, [cartItem]);

  const handleQuantity = (productId, quantity) => {
    for (let product of cartItems) {
      if (product.prod_id === productId) {
        product.quantity = quantity;
      }
    }
    localStorage.setItem("cartitems", JSON.stringify(cartItems));
    setCartItem(cartItems);
    getTotal();
  };
  const [imageUrl, setImageUrl] = useState("");

  useEffect(() => {
    // Load the image
    const img = new Image();
    img.onload = () => {
      setImageUrl(cart.image);
    };
    img.src = cart.image;
  }, [cartItem]);

  const decrement = () => {
    if (select >= 2) {
      setSelect(select - 1); 
         handleQuantity(cart.prod_id, select - 1);
    } else {
      setSelect(1);
      handleQuantity(cart.prod_id, select);
    }

  };

  const increment = () => {
    setSelect(select + 1);
    handleQuantity(cart.prod_id, select + 1);
  };

  return (
    <SidebarCard>
      <img
        src={imageUrl}
        alt="image1"
        onClick={() =>
          navigate(`/itemdetails/${cart.prod_id}/${cart.categ_id}`)
        }
      />
      <div className="price">${cart.price}</div>
      <Control>
        <IncrementButton>
          <button className="left" onClick={decrement}>
            <HiMinus />
          </button>
          <div>{select}</div>
          <button className="right" onClick={increment}>
            <HiOutlinePlus />
          </button>
        </IncrementButton>
        <p onClick={() => handleDelete(cart.prod_id)}>
          <AiOutlineDelete />{" "}
        </p>
      </Control>
    </SidebarCard>
  );
};

export default SideBarProductCard;

const SidebarCard = styled.div`
  width: 90%;
  height: 24vh;
  padding-bottom: 10px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  margin-top: 10px;
  border-bottom: 1px solid black;
  img {
    height: 14vh;
    width: 70%;
    object-fit: contain;
    cursor: pointer;
    @media (max-width: 470px) {
      width: 80%;
    }
  }
  .price {
    font-size: 14px;
    padding: 2px 0;
  }
`;

const Control = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  p {
    cursor: pointer;
    font-size: 17px;
    @media (max-width: 470px) {
      font-size: 16px;
    }
  }
`;

const Quantity = styled.div`
  display: flex;
  align-items: center;

  background-color: #ffffff;
  width: 60%;
  font-size: 12px;
  height: 20px;
  padding: 1px;
  border-radius: 5px;
  border: 1px solid #b9abb6;
  select {
    width: 100%;
    border: none;
    outline: none;
  }
`;

const IncrementButton = styled.div`
  display: flex;
  width: 60%;
  border: 1px solid #f1c1c1;
  justify-content: space-between;
  align-items: center;
  padding: 7px 7px;
  border-radius: 40px;
  transform: scale(0.8);
@media (max-width: 470px) {
      width: 70%;
      padding: 4px 4px;
    }
  button {
    outline: none;
    border: 1px solid #717171;
    color: #f8f2f2;
    :hover {
      transform: scale(1.07);
    }
  }
  .left,
  .right {
    width: 20px;
    height: 20px;
    border-radius: 50%;
    background: #dc87d1;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    svg {
      font-weight: 700;
      color: #05020b;
      transform: scale(1.7)
    }
  }
`;
